import { render } from "./paymentMethods.vue?vue&type=template&id=057b6749&scoped=true"
import script from "./paymentMethods.vue?vue&type=script&lang=js"
export * from "./paymentMethods.vue?vue&type=script&lang=js"

import "./paymentMethods.vue?vue&type=style&index=0&id=057b6749&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057b6749"]])

export default __exports__